var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsMvd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 78,
    viewBox: "0 0 69 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7094 38.8465C63.7217 43.4604 63.7695 46.7048 65.103 50.9949C66.142 54.1799 65.5152 57.4233 64.13 60.6385C62.7464 63.8503 60.3779 66.4445 57.1974 68.009C53.1518 69.784 48.4324 69.9969 44.3073 68.61C38.3229 66.6155 32.3688 64.5417 26.516 62.0203C20.6595 59.4973 14.9942 56.7627 9.50567 53.6172C5.66055 51.5705 2.57373 47.9946 1.08817 43.8367C0.040569 40.4507 0.295177 36.9459 1.67886 33.734C3.06396 30.5189 4.99419 27.8369 8.01886 26.4026C12.1365 24.4609 14.4471 22.2325 16.4347 17.6186L17.109 16.0535C19.7709 9.87468 23.0522 6.49815 27.9289 3.90978C35.131 0.173809 44.1827 -0.0281423 51.6638 3.19477L51.9922 3.33626C59.634 6.62841 65.8776 13.6171 67.923 21.6309C69.2625 26.8007 68.9754 31.2654 66.3836 37.2814L65.7094 38.8465ZM12.4926 64.982C13.2896 63.1319 15.3524 63.0158 17.0786 63.3296C19.0824 63.7325 30.2729 68.5534 31.9421 69.7329C33.3559 70.7719 34.6884 72.3507 33.8914 74.2007C33.0412 75.9225 31.3356 77.0387 29.4809 77.4152C27.0081 78.0607 24.4422 78.0389 22.0293 77.3897C20.7032 77.0113 19.4677 76.4834 18.3271 75.7947C16.1942 74.4856 14.4157 72.6358 13.1915 70.3932C12.1858 68.7888 11.8252 66.7824 12.4926 64.982Z",
    fill: "url(#paint0_linear_4300_3297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4300_3297",
    x1: 58.8695,
    y1: -13.0843,
    x2: 7.61427,
    y2: 105.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsMvd);
export default __webpack_public_path__ + "static/media/stats-mvd.52f06d8c3271d47eeac8d82aa49a31d1.svg";
export { ForwardRef as ReactComponent };